import React, { useEffect, useState } from 'react';
import { Select, Card, Switch, message, Skeleton } from 'antd';
import { toast } from 'react-toastify';
import axios from 'axios';
import FilterBotsUI from '../FilterBots/FilterBotsUI';


const BotSetting = () => {

  const [botdata, setbotdata] = useState([])
  const [childData, setChildData] = useState(null);
  const [loading, setloading] = useState(false)

  const handleChildData = (data) => {
    setChildData(data);  
  };

  const toggleSwitch = (bot) => {
    const jwt = localStorage.getItem('jwt');
    const postData = {
        jwt: jwt,
        exchange_type: [bot.Exchange_Type],
        exchange: [bot.Exchange],
        investment_risk: [bot.Investment_Risk],
        bot_name: [bot.Bot_Name],
        quote_asset: [bot.Quote_Asset],
        symbol: [bot.Symbol],
        status: !bot.CopyTrade_Enabled,  // Toggle the status
        copytradeid:[bot.CopyTradeID]
    };

    // Make API call to update bot's status
    axios({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: process.env.REACT_APP_API + '/bot/edit_bot_list',
        data: postData,
    })
    .then(res => {
        if (res?.data?.Success) {
            // After updating, update the local state to reflect the changes
            View_AllBots()
            toast.success('Bot status updated successfully!');
        } else {
            toast.error('Failed to update bot status');
        }
    })
    .catch(err => {
        toast.error(err?.response?.data?.Error || 'An error occurred');
    });
};


  const View_AllBots = () => {
    setloading(true)
    const jwt = localStorage.getItem('jwt');

    const postdata = {
        jwt: jwt,
     
    };

    

    if (childData?.exchange_type && childData?.exchange_type !== "ALL") {
     
      postdata.exchange_type = [childData?.exchange_type];
    }
  
    if (childData?.exchange && childData?.exchange !== "ALL") {
      postdata.exchange = [childData.exchange];
    }
  
    if (childData?.risk && childData?.risk !== "ALL") {
      postdata.investment_risk = [childData.risk];
    }
  
    if (childData?.botname && childData?.botname !== "ALL") {
      postdata.bot_name = [childData.botname];
    }
  
    if (childData?.quote_asset && childData?.quote_asset !== "ALL") {
      postdata.quote_asset = [childData.quote_asset];
    }
  
    if (childData?.symbol && childData?.symbol !== "ALL") {
      postdata.symbol = [childData.symbol];
    }



    axios({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url: process.env.REACT_APP_API + '/bot/view_bot_list',
        data: postdata
    }).then(res => {
        if (res?.data?.Success ) {
          
            setbotdata(res?.data?.Success);
            setloading(false)
           
        } else {
           
        }
    }).catch(err => {
        toast.err(err.res.data.Error)
        setloading(false)

    });
};

useEffect(() => {
setbotdata([])
    View_AllBots()
}, [childData])




  return (
    <div className="space-y-8">
      {/* Filter Section */}
     <FilterBotsUI onDataSend={handleChildData}/>
  
      {/* Grid Section of Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
     {botdata.length > 0  ? <> {botdata?.map((bot) => (
                <div className="p-4 border rounded-lg shadow-lg" key={bot.Bot_ID}>
                    <Card
                        title={bot.Bot_Name}
                       
                          
                       
                        className="w-full"
                    >
                        <Switch className='custom-switch' value={bot.CopyTrade_Enabled} onChange={() => toggleSwitch(bot)} />
                        <p><strong>BotID:</strong> {bot.CopyTradeID}</p>
                        <p><strong>Exchange:</strong> {bot.Exchange}</p>
                        <p><strong>Exchange Type:</strong> {bot.Exchange_Type}</p>
                        <p><strong>Bot Name:</strong> {bot.Bot_Name}</p>
                        <p><strong>Symbol:</strong> {bot.Symbol}</p>
                        <p><strong>Risk:</strong> {bot.Investment_Risk}</p>
                    </Card>
                </div>
            ))}</> : <><Skeleton/></>}
           
       
      </div>
    </div>
  );
};

export default BotSetting;
